<div class="flex flex-row flex-wrap justify-between items-center flex-1-0-100" (mouseover)="isMouseOver=true"
     (mouseout)="isMouseOver=false">
  <div>
    <ng-template particleCellDecoratorHost></ng-template>
  </div>
  <button [style.visibility]="isMouseOver ? 'visible' : 'hidden'" (click)="showCellEditor()" mat-icon-button
          class="icon-dropdown-button">
    <mat-icon>create</mat-icon>
  </button>
</div>
